import { Home } from 'views';

export default Home;
